import { userPhoneCheck } from '@/api/user'
export default {
    //规则 返回true则是返回成功，
    account(value) {
        if (!value) return "手机号不能为空";
        if (!/^1[3-9]\d{9}$/.test(value)) return '手机号格式不正确'
        return true;
    },
    password(value) {
        if (!value) return "密码不能为空";
        return true;
    },
    phone(value) {
        if (!value) return "手机号不能为空";
        if (!/^1[3-9]\d{9}$/.test(value)) return '手机号格式不正确'
        return true;
    },
    // 用户校验且校验唯一性
    async phoneApi(value) {
        if (!value) return '手机号不能为空'
        // 服务器端校验
        if (!/^1[3-9]\d{9}$/.test(value)) return '手机号格式不正确'
        const data = await userPhoneCheck(value)
        if (data.code == 201) return ` ${data.msg}`
        return true
    },
    code(value) {
        if (!value) return "验证码不能为空";
        if (!/^\d{6}$/.test(value)) return '短信验证码为6个数字'
        return true;
    },
    rePassword(value, { form }) {
        if (!value) return '密码不能为空';
        // form表单数据对象
        if (value !== form.password) return '两次输入密码不一致'
        return true
    }
}